<mat-form-field appearance="outline" class="field-control w-100">
  <mat-label>{{ label }}</mat-label>

  <mat-date-range-input [rangePicker]="picker" >
    <input matStartDate placeholder="Desde" [value]="values[0]" (dateChange)="onStartChange($event)" >
    <input matEndDate placeholder="Hasta" [value]="values[1]" (dateChange)="onEndChange($event)">
  </mat-date-range-input>

  <mat-date-range-picker #picker></mat-date-range-picker>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>

  <mat-hint class="error-hint">
    @for (error of errors; track error) {
      <span class="bg-warning-500 text-white">
        {{ error.message }}
      </span>
    }
  </mat-hint>

</mat-form-field>

